function lonToX(lon, zoom) {

    var n = Math.pow(2, zoom)
    var x = Math.floor( (lon + 180) / 360 * n )

    return (x)
}

function latToY(lat, zoom) {

    var lat_rad = lat * Math.PI / 180
    var n = Math.pow(2, zoom)
    var y = Math.floor((1 - Math.log(Math.tan(lat_rad) + 1 / Math.cos(lat_rad)) / Math.PI) / 2 * n)

    return (y)
}

exports.tilesInBbox = function(bbox, zoom) {

    var tiles = []

    var xMin = lonToX(bbox.left, zoom)
    var xMax = lonToX(bbox.right, zoom)
    var yMin = latToY(bbox.top, zoom)
    var yMax = latToY(bbox.bottom, zoom)

    var i = xMin
    while (i <= xMax) {
        var j = yMin
        while (j <= yMax) {
            tiles.push({ x : i, y : j, z : zoom })
            j++
        }
        i++
    }

    return (tiles)
}
